import permissions from "app/permissions";
import { getPermissions } from "auth/security/securityUtils";
import {
  List,
  TextField,
  EditButton,
  ShowButton,
  Datagrid,
  ReferenceArrayField,
  SingleFieldList,
  ChipField,
  SimpleList,
  TopToolbar,
  CreateButton,
} from "react-admin";
import SecuredComponent from "server/security/SecuredComponent";
import { checkPermission } from "server/security/utils";
import { MOBILE_BREAKPOINT } from "utils/constants";
import { useMediaQuery } from "@mui/material";
import { EmptyList } from "server/components";
import { settings } from "app";
import { ExportXlsButton } from "features/ExportXlsxButton";
import { SpecificRequirementsExporter } from "./XlsxExporter";
import { administrationRequests } from "api/administrationApi";
import { MobileListRow } from "features/MobileListRow";

export const ListSpecificRequirements = () => {
  const isMobile = useMediaQuery(MOBILE_BREAKPOINT);
  const userPermissions = getPermissions();

  const ListActions = hasCreate => {
    return (
      <TopToolbar>
        {hasCreate && <CreateButton />}
        <ExportXlsButton exporter={SpecificRequirementsExporter} />
      </TopToolbar>
    );
  };

  return (
    <List
      title="Изисквания за специалности"
      actions={
        <ListActions hasCreate={checkPermission(userPermissions, permissions.canCreateSpecificRequirementTypes)} />
      }
    >
      {isMobile ? (
        <SimpleList
          empty={<EmptyList />}
          linkType={false}
          sx={settings.style.mobileList}
          primaryText={record => <MobileListRow fields={[{ label: "Име на български език", value: record.nameBg }]} />}
          secondaryText={record => (
            <div>
              <MobileListRow fields={[{ label: "Име на английски език", value: record.nameEn }]} />
              <MobileListRow
                fields={[
                  {
                    label: "Документи",
                    value: (
                      <ReferenceArrayField
                        source="documentTypeIds"
                        reference={administrationRequests.getPreferenceDocumentTypesSelect()}
                      >
                        <SingleFieldList linkType={false}>
                          <ChipField source="name" />
                        </SingleFieldList>
                      </ReferenceArrayField>
                    ),
                  },
                ]}
              />
            </div>
          )}
          tertiaryText={() => (
            <>
              <SecuredComponent permission={permissions.canUpdateSpecificRequirementTypes}>
                <EditButton label="" />
              </SecuredComponent>
              <SecuredComponent permission={permissions.canPreviewSpecificRequirementTypes}>
                <ShowButton label="" />
              </SecuredComponent>
            </>
          )}
        />
      ) : (
        <Datagrid
          bulkActionButtons={false}
          rowClick={false}
        >
          <TextField
            source="nameBg"
            label="Име на български език"
            sortable={false}
          />
          <TextField
            source="nameEn"
            label="Име на английски език"
            sortable={false}
          />
          <ReferenceArrayField
            source="documentTypeIds"
            label="Документи"
            reference={administrationRequests.getPreferenceDocumentTypesSelect()}
          >
            <SingleFieldList linkType={false}>
              <ChipField source="name" />
            </SingleFieldList>
          </ReferenceArrayField>
          <SecuredComponent permission={permissions.canUpdateSpecificRequirementTypes}>
            <EditButton />
          </SecuredComponent>
          <SecuredComponent permission={permissions.canPreviewSpecificRequirementTypes}>
            <ShowButton />
          </SecuredComponent>
        </Datagrid>
      )}
    </List>
  );
};
export default ListSpecificRequirements;
